// How a capture's filing state is worded and colored, shared by Today's Inbox
// and the recent-captures list in Settings.

import { KIND_LABELS, describeSuggestion } from '@cerebro-diem/core';
import type { Classification, ContainerRow, FilingState } from '@cerebro-diem/core';
import type { CaptureWithClassifications } from '../../services/captures';

export interface InboxEntry {
  capture: CaptureWithClassifications;
  classification: Classification | null;
  state: FilingState;
}

/** What a capture's filing state reads as: where it stands, and the AI's suggestion when it waits for review. */
export function stateLabel({ capture, classification, state }: InboxEntry, containers: readonly ContainerRow[]): string {
  switch (state) {
    case 'filing':
      return 'Filing…';
    case 'failed':
      return capture.processing_error ? `Auto-filing failed: ${capture.processing_error}` : 'Auto-filing failed';
    case 'needs_review':
      return classification
        ? `AI suggests: ${describeSuggestion(classification, containers) ?? KIND_LABELS[classification.category]} (${Math.round(Number(classification.confidence) * 100)}%)`
        : 'Needs review';
    case 'unfiled':
      return 'Not filed';
    case 'filed':
      return 'Filed';
  }
}

/** The text color each filing state is shown in. */
export const STATE_TONES: Record<FilingState, string> = {
  filing: 'text-on-surface-variant',
  failed: 'text-error',
  needs_review: 'text-tertiary font-medium',
  unfiled: 'text-on-surface-variant',
  filed: 'text-success',
};
